import React, { useEffect, useState } from 'react';
import { Alert, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import deliveryService from '../../services/deliveryService';

const AvisoEntregasPendientes = () => {
  const navigate = useNavigate();
  const [pending, setPending] = useState(0);

  useEffect(() => {
    let active = true;
    deliveryService.mine()
      .then((data) => { if (active) setPending(data?.pendingAcknowledgments || 0); })
      .catch(() => { if (active) setPending(0); });
    return () => { active = false; };
  }, []);

  if (pending === 0) return null;
  return (
    <Alert severity="success" sx={{ mt: 2 }}
      action={<Button color="inherit" size="small" onClick={() => navigate('/perfil-riesgo/mis-documentos')}>Ver documentos</Button>}>
      <b>Tienes documentos nuevos de CONEM.</b> Revísalos y confirma que los recibiste ({pending} pendiente{pending === 1 ? '' : 's'}).
    </Alert>
  );
};

export default AvisoEntregasPendientes;
